module.exports = __webpack_public_path__ + "static/media/funfacts.21262a64.png";